<template>
  <v-container fluid class="custom-container">

    <v-layout column class="mt-4 mb-2">
      <router-link
        tag="span"
        class="mb-4 grey--text link-back"
        :to="{ name: 'Employees'}"
      >
        <v-icon size="18">mdi-chevron-left</v-icon>
        Voltar para funcionários
      </router-link>

      <v-layout v-if="hasEmployee">
        <v-avatar size="70">
          <v-img :src="employee.avatar || imageUrl"/>
        </v-avatar>

        <v-layout column class="ml-4">
          <h2>
            Processos de
            <span class="text-capitalize">{{ employee.name.toLowerCase() }}</span>
          </h2>
          <span class="grey--text">{{ employeeDate }}</span>

          <v-layout wrap>
            <v-btn flat color="docgo" class="ml-0" @click="editEmployee">
              Editar usuário
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!!employee.rescission_date && foldersCount"
              color="docgo white--text"
              @click="openFolderTransferDialog"
            >
              Transferir processos
            </v-btn>
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout v-else>
        <h2>Funcionário não encontrado</h2>
      </v-layout>
    </v-layout>

    <v-divider></v-divider>

    <v-layout
      v-if="hasFolder"
      class="mb-0 list-folders-actions"
      justify-space-between
    >
      <v-flex xs4>
        <span>Exibindo {{ pageStart }} - {{ pageStop }} de {{ foldersCount }}</span>
        <v-btn icon @click="pageNumber--" :disabled="pageNumber <= 1">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon @click="pageNumber++" :disabled="pageNumber >= pages">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs3>
        <v-select
          v-model="orderFilter"
          :items="orderFilters"
          item-text="name"
          return-object
          hide-details
          solo
          flat
        />
      </v-flex>
    </v-layout>

    <section class="folders" v-if="hasFolder">
      <v-layout
        class="folder-list mt-4"
        v-for="(group,index) in groupedFolders"
        :key="index"
        column
      >
        <span class="subheading grey--text my-2 text-capitalize"> {{ index }}</span>

        <div class="elevation-1 group" v-if="group.length > 0">
          <v-layout
            class="item"
            v-for="folder in group"
            :key="folder.id"
            @click.stop="openFolder(folder.id)"
            justify-center
            align-center
            row
            wrap
          >
            <v-flex class="pa-2" xs4>
              <v-menu open-on-hover top offset-y style="width: 100%">
                <v-layout class="folder-name" align-center row slot="activator">
                  <img
                    class="d-flex mx-3 folder-icon"
                    :src="folderIcon"
                    alt="Ícone de Pasta"
                  >
                  <v-layout column>
                    <v-flex class="grey--text">
                      <span class="caption process-number">{{ folder.process_number }}</span>
                    </v-flex>
                    <v-flex class="type-name">
                      <span>{{ folder.folder_type.name }}</span>
                    </v-flex>
                  </v-layout>
                </v-layout>
                <v-card dark class="pa-2" v-if="folder.subject">
                  <span class="grey--text"> {{folder.subject}}</span>
                </v-card>
              </v-menu>
            </v-flex>

            <v-flex class="pa-2" xs3 xl4>
              <v-chip color="grey-lighten-2 entity-chip">
                <v-avatar size="16" color="white">
                  <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                </v-avatar>
                <strong class="grey--text text--darken-2 text-truncate">{{ folder.entity.name }}</strong>
              </v-chip>
            </v-flex>

            <v-spacer></v-spacer>

            <v-flex class="pa-2" xs2>
              <v-layout justify-center>
                <span class="caption"><term-component :folder="folder"></term-component></span>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
    </section>

    <v-container fill-height v-if="!hasFolder && !loading.show">
      <v-layout column align-center>
        <v-icon class="mt-5 mb-2" size="48" color="grey darken-2">mdi-inbox</v-icon>
        <span class="title font-weight-regular grey--text text--darken-2">
          Não há itens para exibir
        </span>
      </v-layout>
    </v-container>

    <employee-form
      :dialog.sync="showDialogUser"
      :roles="roles"
      :administrativeUnits="administrativeUnits"
    />

    <folder-transfer-dialog
      :employee="employee"
      ref="folderTransfer"
    />

  </v-container>
</template>

<script>
import { isEmpty } from 'lodash';
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import foldersService from '@/services/FoldersService';
import RoleService from '@/services/system/RoleService';
import TermComponent from '@/components/inbox/TermComponent';
import EmployeeForm from "@/components/employees/EmployeeForm";
import EmployeeService from '@/services/system/EmployeeService';
import FolderTransferDialog from '@/components/folder/entity/FolderTransferDialog';
import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';

export default {
  name: 'employee-folder',
  props: ['id'],
  components: {
    TermComponent,
    EmployeeForm,
    FolderTransferDialog,
  },
  mounted() {
    this.getEmployee();
    this.loadRoles();
    this.loadAdministrativeUnits();
  },
  data() {
    return {
      orderFilters: [
        { name: 'Tramitação mais antiga', property: 'effective_updated_at', order: 'asc' },
        { name: 'Tramitação mais recente', property: 'effective_updated_at', order: 'desc' },
      ],
      orderFilter: {
        name: 'Tramitação mais recente',
        property: 'effective_updated_at',
        order: 'desc',
      },
      hasEmployee: false,
      employee: {},
      folders: [],
      foldersCount: 0,
      pages: 0,
      pageNumber: 1,
      rowsPerPage: 20,
      showDialogUser: false,
      roles: [],
      administrativeUnits: [],
      imageUrl: '/static/images/settings/new-icons/user.svg',
      folderIcon: '/static/images/folder/folder-closed-icon.svg',
      isEmpty,
    };
  },
  methods: {
    getEmployee() {
      this.hasEmployee = false;

      EmployeeService
        .getEmployee(this.id)
        .then(({ data }) => {
          this.employee = data;
          this.hasEmployee = true;
          this.getFolders();
        });
    },
    getFolders(loading = true) {
      if (loading) {
        this.$store.dispatch('toggleLoader', { show: true });
      }

      foldersService
        .getEmployeeFolders({
          id: this.id,
          page: this.pageNumber,
          limit: this.rowsPerPage,
          order: this.orderFilter.order,
          sort: this.orderFilter.property
        })
        .then(({ data }) => {
          this.pages = data.total_pages;
          this.foldersCount = data.total;
          this.folders = data.folders || data.employee_folders;
        })
        .finally(() => {
          this.$store.dispatch('toggleLoader', { show: false });
        });
    },
    openFolder(folderId) {
      const route = this.$router.resolve(`/pastas/${folderId}/show`);
      window.open(route.href, '_blank');
    },
    formatDate(date) {
      return format(date, 'DD/MM/YYYY');
    },
    formatMonthYear(date) {
      return format(date, 'MMMM [de] YYYY', { locale: ptLocale });
    },
    orderDateToString(folder) {
      switch (this.orderFilter.property) {
        case "updated_at":
          // Usar o sort_updated_at que vem do backend
          const date = folder.sort_updated_at || folder.updated_at;
          return this.formatMonthYear(date);
        default:
          if (folder.last_transaction == null) {
            return 'Processos não tramitados';
          }
          return this.formatMonthYear(folder.last_transaction.created_at);
      }
    },
    openFolderTransferDialog() {
      this.$refs.folderTransfer.open();
    },
    loadRoles() {
      RoleService
        .all()
        .then(({ data }) => this.roles = data);
    },
    loadAdministrativeUnits() {
      AdministrativeUnitService
        .all()
        .then(({ data }) => this.administrativeUnits = data);
    },
    editEmployee() {
      this.$store.dispatch('setEmployee', this.employee);
      this.showDialogUser = true;
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    hasFolder() {
      return !this.isEmpty(this.groupedFolders);
    },
    groupedFolders() {
      const group = {};
      this.folders.forEach((folder) => {
        if (group[this.orderDateToString(folder)] == null) {
          group[this.orderDateToString(folder)] = [folder];
        } else {
          group[this.orderDateToString(folder)].push(folder);
        }
      });
      return group;
    },
    employeeDate() {
      const employee = this.employee;
      if (employee.rescission_date) {
        return `Demissão em: ${this.formatDate(employee.rescission_date)}`;
      }
      return `Admissão em: ${this.formatDate(employee.admission_date)}`
    },
    pageStart() {
      return (this.pageNumber * this.rowsPerPage) - (this.rowsPerPage - 1);
    },
    pageStop() {
      return Math.min(this.pageStart + (this.rowsPerPage - 1), this.foldersCount);
    },
  },
  watch: {
    pageNumber: {
      handler: 'getFolders',
      immediate: true,
    },
    orderFilter: {
      handler: 'getFolders',
    },
  },
};
</script>

<style scoped lang="scss">
  .custom-container {
    height: calc(100vh - 60px);
    position: relative;
    overflow: hidden;
  }

  .folders {
    overflow-y: auto;
    height: 75%;
    margin-top: 24px;
    padding-right: 25px;
  }

  .list-folders-actions {
    position: absolute;
    z-index: 4;
    width: 97%;
    background: white;
    margin-top: 6px;
  }

  .employee-name {
    text-transform: lowercase;
  }

  .link-back {
    cursor: pointer;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/folder/list/employee/EmployeeFolder.vue